<template>
  <div :style="{ width }">
    <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label" :vid="name">
      <CTextarea
              :invalidFeedback="errors[0]"
              :name="name"
              v-model="localValue"
              :isValid="errors[0] ? false : null"
              :placeholder="placeholder"
              :class="largeHeight ? $style['textarea'] : ''"
      ></CTextarea>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    rules: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    width: {
      type: String,
      default: "60%"
    },
    largeHeight: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style module lang="scss">
.textarea-field {
  font-size: 13px;
}
.textarea textarea {
  height: 100px;
}
</style>
